import { render } from "./PlaceholderCheckEditor.vue?vue&type=template&id=400f11ea"
import script from "./PlaceholderCheckEditor.vue?vue&type=script&lang=ts"
export * from "./PlaceholderCheckEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script